const languages = [
  {code: 'en', short: 'ENG'},
  {code: 'mk', short: 'MKD'},
  {code: 'sq', short: 'ALB'},
  {code: 'sr', short: 'SRB'},
];

export default languages;
